import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './forsi.scss'

// Actions
import { getForsiInformation, saveForsiInformation } from '../../../actions/settings'
import { getCustomers } from '../../../actions/customers'
import { getAuthResources } from '../../../actions/auth'

import { openPopup, closePopup } from '../../../actions/common'

// Elements
import Col from '../../../shared/elements/col'
import Row from '../../../shared/elements/row'
import Panel from '../../../shared/elements/panel'
import Radio from '../../../shared/elements/radio'
import Text from '../../../shared/elements/text'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import DropDown from '../../../shared/elements/dropDown'
import Switch from '../../../shared/elements/switch'

// Utils
import { translation } from '../../../utils/helpers'

class Forsi extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Forsi: {
        ShopId: 0,
        Active: false,
        UserName: '',
        Password: '',
        ForsiBodyShopId: '',
        AutoUpdate: false,
        UpdateCompleted: false,
        UpdateCompletedManuel: false,
        UpdateInvoiced: false,
        ShowPrices: false,
        ShowAe: false,
        ShopCustomerId: null,
        UsesToken: false,
        TokenActive: '',
        Token: ''
      },
      Customers: [],
      randradio: 0,
      randcheck: [],
      dropper: '3',
      switcher: []
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.getForsiInformation()
    this.props.getCustomers(this.props.auth.user.ShopId).then((res) => {
      this.setState({
        Customers: res.data
      // }, () => {
      //   console.log('[Forsi] got customers', this.state)
      })
    })
  }

  getForsiInformation () {
    this.props.getForsiInformation(this.props.auth.user.ShopId).then((res) => {
      this.setState({
        Forsi: {
          ShopId: res.data.ShopId,
          Active: res.data.Active,
          UserName: res.data.UserName,
          Password: res.data.Password,
          ForsiBodyShopId: res.data.ForsiBodyShopId,
          AutoUpdate: res.data.AutoUpdate,
          UpdateCompleted: res.data.UpdateCompleted,
          UpdateCompletedManuel: res.data.UpdateCompletedManuel,
          UpdateInvoiced: res.data.UpdateInvoiced,
          ShowPrices: res.data.ShowPrices,
          ShowAe: res.data.ShowAe,
          ShopCustomerId: res.data.ShopCustomerId,
          UsesToken: res.data.UsesToken,
          TokenActive: res.data.TokenActive,
          Token: res.data.Token
        }
      })
    }, (err) => {
      console.log(err)
    })
  }

  onChange (e) {
    e.persist()
    let value = e.target.value

    if (e.target.name === 'UpdateCompleted') {
      let updateCompleted = e.target.value === 'yes'
      let updateCompletedManual = e.target.value === 'manual'
      this.setState({
        Forsi: {
          ...this.state.Forsi,
          UpdateCompleted: updateCompleted,
          UpdateCompletedManuel: updateCompletedManual
        }
      }, () => {
        if (e.target.type === 'radio') {
          this.onBlur(e)
        }
      })
    } else {
      if (e.target.type === 'radio') {
        value = (e.target.value === 'yes')
      }
      if (e.target.type === 'checkbox') {
        console.log('checkbox', e.target.name, e.target.checked)
        value = e.target.checked
      }
      if (e.target.type === 'select-one') {
        value = Number(value)
      }
      this.setState({
        Forsi: {
          ...this.state.Forsi,
          [e.target.name]: value
        }
      }, () => {
        if (e.target.type === 'radio' || e.target.type === 'select-one' || e.target.type === 'checkbox') {
          this.onBlur(e)
        }
      })
    }
  }

  onBlur (e) {
    this.props.saveForsiInformation(this.state.Forsi).then(() => {
      // Toastr (replace dict. key)
      // window.toastr.success(translation('1722'), translation('13424'))
      this.props.getAuthResources()
    }, () => {
      if (this.state.Forsi.UserName === null || this.state.Forsi.Password) {
        window.toastr.error(translation('2077'))
      }
      // Toastr (replace dict. key)
      window.toastr.error(translation('1723'), translation('216'))
    })
  }

  renderForsiToken () {
    const {Forsi} = this.state
    // console.log(Forsi)
    if (!Forsi.UsesToken) return null

    return (
      <Panel title={translation(16421)}>
        <Switch name='TokenActive' onChange={this.onChange} checked={Forsi.TokenActive} labelText={translation('295')} />
        {Forsi.TokenActive ? <Text name='Token' value={Forsi.Token} onChange={this.onChange} onBlur={this.onBlur} labelText={'Token'} /> : null}
      </Panel>
    )
  }

  render () {
    let { Forsi } = this.state
    // console.log('[Forsi] render', this.props, this.state)
    const customersList = (val, key) => {
      return (
        <option key={val.CustomerId} value={val.CustomerId}>{val.Name}</option>
      )
    }

    const renderForsiColumn = () => {
      if (this.props.auth.permissions.ChainAssessmentSystem !== 1) return null
      return (
        <Col>
          <Panel title={translation('13438')}>
            <Switch id='Active' name='Active' checked={Forsi.Active} value='1' onChange={this.onChange} labelText={translation('295')} />
            <Text name='UserName' value={Forsi.UserName} onChange={this.onChange} onBlur={this.onBlur} labelText={translation(1)} />
            <Text name='Password' value={Forsi.Password} onChange={this.onChange} onBlur={this.onBlur} labelText={translation(2)} />
            <Text name='ForsiBodyShopId' value={Forsi.ForsiBodyShopId} onChange={this.onChange} onBlur={this.onBlur} labelText={translation(14803)} />

            {this.props.auth.user.DepartmentType === 1 && (
              <LabelWrapper labelText={translation('14905')} helpText={translation('14907')}>
                <DropDown onChange={this.onChange} name='ShopCustomerId' value={Forsi.ShopCustomerId}>
                  <option key={null} value={null}>{translation('14906')}</option>
                  {this.state.Customers.map(customersList)}
                </DropDown>
              </LabelWrapper>
            )}
          </Panel>
        </Col>
      )
    }

    let autoUpdateText = null
    let autoUpdateHelpText = null
    switch (this.props.auth.permissions.ChainAssessmentSystem) {
      case 1:
        autoUpdateText = translation('942')
        autoUpdateHelpText = translation('1996')
        break
      case 2:
        autoUpdateText = translation('18066')
        autoUpdateHelpText = translation('18067')
        break
      default:
        break
    }

    return (
      <div className='forsi__page'>
        <form>
          <Row>
            {renderForsiColumn()}
            <Col>
              <Panel title={translation('998')}>
                <Switch id='AutoUpdate' name='AutoUpdate' checked={Forsi.AutoUpdate} value='1' onChange={this.onChange} labelText={autoUpdateText} helpText={autoUpdateHelpText} />
                <LabelWrapper labelText={translation('1250')} helpText={translation('1997')}>
                  <Radio id='UpdateCompleted_yes' name='UpdateCompleted' labelText={translation('47')} onChange={this.onChange} value='yes' checked={Forsi.UpdateCompleted} />
                  <Radio id='UpdateCompleted_no' name='UpdateCompleted' labelText={translation('48')} onChange={this.onChange} value='no' checked={!Forsi.UpdateCompleted && !Forsi.UpdateCompletedManuel} />
                  <Radio id='UpdateCompleted_manual' name='UpdateCompleted' labelText={translation('1619')} onChange={this.onChange} value='manual' checked={!Forsi.UpdateCompletedManuel} />
                </LabelWrapper>
                <Switch id='UpdateInvoiced' name='UpdateInvoiced' checked={Forsi.UpdateInvoiced} value='1' onChange={this.onChange} labelText={translation('1251')} helpText={translation('1998')} />
              </Panel>
            </Col>

            <Col>
              <Panel title={translation('420')}>
                <Switch id='ShowAe' name='ShowAe' checked={Forsi.ShowAe} value='1' onChange={this.onChange} labelText={translation('422')} />
                <Switch id='ShowPrices' name='ShowPrices' checked={Forsi.ShowPrices} value='1' onChange={this.onChange} labelText={translation('423')} />
              </Panel>
            </Col>
            <Col span={2}>
              {this.renderForsiToken()}
            </Col>
          </Row>
        </form>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getForsiInformation,
  saveForsiInformation,
  getCustomers,
  getAuthResources,

  openPopup,
  closePopup
})(Forsi)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/Forsi/index.js